import { Component, EventEmitter, Inject, Output } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { NavigationEnd, Router } from '@angular/router';
import { NavigationService } from 'src/app/services/navigation.service';
import { UserSessionService } from 'src/app/services/usersession.service';
import swal from 'sweetalert2';

@Component({
    selector: 'app-account-menu',
    templateUrl: './account-menu.component.html',
    styleUrls: ['./account-menu.component.scss'],
})
export class AccountMenuComponent {
    @Output() closeMenu: EventEmitter<void> = new EventEmitter<void>();
    userName: string;
    userId: number;

    constructor(
        private userSessionService: UserSessionService,
        private navigate: NavigationService,
        private msalService: MsalService,
        private router: Router,
    ) {
        this.userName = this.userSessionService.userName();
        this.userId = this.userSessionService.getUserIdFromSession();
    }

    logout(e) {
        const logoutData = {
            userId: this.userId,
        };
        e.preventDefault();
        const title = 'Logout Confirmation';
        const txt = 'Do you want to logout?';
        const Yes = 'Yes';
        const No = 'No';
        swal.fire({
            title,
            text: txt,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#7D32DE',
            cancelButtonColor: '#23C00A',
            confirmButtonText: Yes,
            cancelButtonText: No,
        }).then((result) => {
            if (result.value) {
                localStorage.clear();
                this.navigate.login();
            }
        });
    }

    ChangePassword() {
        this.navigate.myaccount(2);
    }
    Profile() {
        this.navigate.myaccount(0);
    }
}
